// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__Pf3WB","error":"InputSecondary_error__3zAEX","disabled":"InputSecondary_disabled__30OW6"};